function SidebarBody({ children }) {
  return (
    <div className="flex flex-grow flex-col bg-primary-900 pt-2 pb-24 dark:border-r dark:border-gray-700 dark:bg-gray-800 overflow-y-auto overflow-x-hidden">
      {children}
    </div>
  );
}

export default SidebarBody;
